import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgHelp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12 3c-4.968 0-9 4.032-9 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9zm.9 15.3h-1.8v-1.8h1.8v1.8zm1.863-6.975l-.81.828c-.648.657-1.053 1.197-1.053 2.547h-1.8v-.45c0-.99.405-1.89 1.053-2.547l1.116-1.134A1.76 1.76 0 0 0 13.8 9.3c0-.99-.81-1.8-1.8-1.8s-1.8.81-1.8 1.8H8.4c0-1.989 1.611-3.6 3.6-3.6s3.6 1.611 3.6 3.6c0 .792-.324 1.512-.837 2.025z",
			fillRule: "nonzero"
		})
	})
});
export default SvgHelp;
